import { FC, ChangeEvent, useState, useEffect } from 'react';
import { InputGroup } from '@/components/InputGroup';

import styles from './InputSwitch.module.sass';

interface SwitchOption {
  label: string;
  value: string;
}

interface InputSwitchProps {
  name: string;
  options: SwitchOption[];
  onChange: (value: string) => void;
}

const InputSwitch: FC<InputSwitchProps> = (props) => {
  const { name, options = [], onChange } = props;
  const [selection, setSelection] = useState('');

  useEffect(() => {
    setSelection(options[0].value);
  }, []);

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSelection(val);
    onChange(val);
  };

  return (
    <InputGroup>
      <div className={styles.wrapper}>
        {options.map((option) => (
          <div
            key={option.value}
            className={`${styles.option}
              ${selection === option.value ? styles['option--checked'] : ''}`}
          >
            <input
              type="radio"
              id={`option-${option.value}`}
              name={name}
              className={styles.field}
              value={option.value}
              checked={selection === option.value}
              onChange={changeHandler}
            />
            <label className={styles.label} htmlFor={`option-${option.value}`}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </InputGroup>
  );
};

export default InputSwitch;
